// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2H76Z","author":"Table_author__1tBmr","authorImage":"Table_authorImage__3E43J","unreadRow":"Table_unreadRow__1X7Xj"};